import { render, staticRenderFns } from "./EventCompany.vue?vue&type=template&id=dee6317a&scoped=true"
import script from "./EventCompany.vue?vue&type=script&lang=ts"
export * from "./EventCompany.vue?vue&type=script&lang=ts"
import style0 from "./EventCompany.vue?vue&type=style&index=0&id=dee6317a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee6317a",
  null
  
)

export default component.exports